// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._39uhFNx7ELuFd7kDlBu4pE{display:flex;align-items:center;justify-content:center;position:relative}.KblPVUl7hYRRxqdrmxilr{position:absolute;width:100%}._3DqdvyoF1r1i9vYdHnZoIy{width:100%;transform:scale(1.1);filter:brightness(0) invert(1)}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"strokedEmoteImage": "_39uhFNx7ELuFd7kDlBu4pE",
	"strokedEmoteImage__img": "KblPVUl7hYRRxqdrmxilr",
	"strokedEmoteImage__stroke": "_3DqdvyoF1r1i9vYdHnZoIy"
};
export default ___CSS_LOADER_EXPORT___;
